import Immutable from 'immutable';

const Content: {
  activeKeyword: string,
  keywordToAscending: Immutable.Map<string, boolean>
} = {
  activeKeyword: '',
  keywordToAscending: Immutable.Map()
};

class TableSortPreferences extends Immutable.Record(Content) {
  setAscending (keyword: string, ascending: boolean): TableSortPreferences {
    return this.set('keywordToAscending', this.keywordToAscending.set(keyword, ascending));
  }

  getAscending (keyword: string): boolean {
    const retval = this.keywordToAscending.get(keyword);
    if (retval != null) {
      return retval;
    }

    return true;
  }
}

export default TableSortPreferences;
